import { useEffect, useRef } from 'react';

const isScrollable = (element) => {
  if (!element || typeof window === 'undefined') return false;
  const { overflowY } = window.getComputedStyle(element);
  return (overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight;
};

export const useScrollToTopOnMount = (trigger) => {
  const ref = useRef(null);

  useEffect(() => {
    // Only null/false suppress the scroll. An omitted trigger (undefined) must still scroll on mount,
    // which ErrorDrawer and SuccessDrawer rely on, so don't simplify this to `!trigger`.
    if (trigger === null || trigger === false) return;
    try {
      let node = ref.current;
      while (node && !isScrollable(node)) {
        node = node.parentElement;
      }
      if (node) {
        node.scrollTop = 0;
      }
    } catch (error) {
      // intentionally ignored
    }
  }, [trigger]);

  return ref;
};
